import * as React from 'react';
import {Artist} from 'types/Artist';

interface ThankYouProps {
	readonly specialThanks: string[];
	readonly manyThanks: string[];
	readonly artists: Artist[];
	readonly places: string[];
}

export default class ThankYou extends React.Component<ThankYouProps>{
	static defaultProps = {
		specialThanks: [
			"George Lucas for dreaming this world.",
			"Philip Kuperberg for amazing technical creativity (& putting up with me)",
			"Michael Plecha for project management.",
			"Felice Kofler for additional layouts.",
			"Scott Beale for words of guidance."
		],
		manyThanks: [
			"Brie Burkeman",
			"Nick Auerbach",
			"Carlo McCormick",
			"Orbi",
			"Ned White",
			"Greg Hoffman",
			"Sean Johnson ",
			"Sofia Pasternack",
			"Jenn Welch",
			"Allie Antman",
			"Jacob Hoye",
			"Ron Workman",
			"Brian Wagner",
			"Andrew Goldstone ",
			"mother's tankstation ",
			"Robert Fontaine Gallery",
			"Luna Park",
			"Scott Briscoe",
			"Paul Instigator Weston",
			"Kathy Grayson",
			"Stephen Mead",
			"Rodney Payne",
			"Alex Emmart",
			"Dov Kelemer",
			"Jaime Rojo &amp; Steven P. Harrington",
			"Martha Fleming-Ives",
			"Nick Jones ",
			"Charlie Phillips",
			"Rebekah Smith",
			"Pete Ware",
			"David Eger",
			"72 Pins"
		],
		places: [
			"http://www.LaughingSquid.com",
			"http://www.TieFighters.com",
			"http://theartofstarwars.tumblr.com",
			"http://theemperialmarch.tumblr.com",
			"http://shot-first.tumblr.com",
			"http://boomerstarkiller67.tumblr.com",
			"http://www.Society6.com",
			"http://www.ETSY.com"
		]
	}
	render(){
		let {
			specialThanks,
			manyThanks,
			artists,
			places
		} : ThankYouProps = this.props;
		return (
			<div className="thank-you">
				<h1>Special thanks :</h1>
				<ul className="special-thanks">{
					specialThanks.map((t, idx) =>
						<li key={idx}>{t}</li>
					)
				}</ul>
				<h2>Many thanks also to:</h2>
				<ul className="many-thanks">{
					manyThanks.map(t =>
						<li key={t}>{t}</li>
					)
				}</ul>
				<p>Sincere gratitude and respect to all the artists.<br />
					{`I hope you’re happy being included. My intent was simply to showcase your wonderful work.`}</p>
				<ul className="artist-thanks">
					{artists.map(a =>
						<li key={a.name}>
							<a rel="noopener" target="_blank" title={a.name} href={a.url}>{
								a.name
							}</a>
						</li>
					)}</ul>
				<h2 className="grateful">Places I'm grateful to, where I found many STAR WARPS.</h2>
				<ul className="places-thanks">{
					places.map(p =>
						<li key={p}>
							<a rel="noopener" target="_blank" href={p}>{
								p.replace('http://', '')
							}</a>
						</li>
					)
				}
				</ul>
			</div>
		)
	}
}